let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b90Ou")).then(() => parcelRequire('96cJs'));